var React = require('react');

function DownArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#3D4E56","fillRule":"nonzero","d":"M7.603.225c.32-.3.838-.3 1.157 0 .32.3.32.788 0 1.088L5.08 4.775c-.32.3-.838.3-1.158 0L.24 1.313a.737.737 0 0 1 0-1.088c.32-.3.837-.3 1.157 0L4.5 3.143 7.603.225z"}));
}

DownArrow.defaultProps = {"width":"9","height":"5","viewBox":"0 0 9 5"};

module.exports = DownArrow;

DownArrow.default = DownArrow;
